import { Snackbar } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import update from "immutability-helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
import $ from "jquery";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";

import PurchaseService from "../../services/PurchaseOrder";
import UploadAndDownloadService from "../../services/uploadAndDownloadFile";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableTransactionEndRecieve from "../../ui/DataTableTransactionEndRecieve";
import { Link } from "react-router-dom";
import NumericInput from "react-numeric-input";
import CurrencyInput from "react-currency-input";
import withLoader from './../../components/layouts/WithLoader';

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));

function getSteps() {
  return [
    "Choisir l'ordre de production",
    "Choisir les produits et les quantités",
    "Finaliser",
  ];
}

const ReceiveAPurchaseOrder = ({ startLoading, stopLoading }) => {
  // const dispatch = useDispatch();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [infoAlertText, setInfoAlertText] = useState();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [product, setProduct] = React.useState(0);
  const [currentQteProductPurchase, setCurrentQteProductPurchase] =
    React.useState("nothing");
  const [amount, setAmount] = React.useState(0);
  const [nbr, setNbr] = React.useState(0);

  const [productTableData, setProductTableData] = React.useState([]);
  const [productMapById, setProductMapById] = React.useState([]);
  const [factureOrPurchaseOrderReference, setFactureOrPurchaseOrderReference] =
    useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [bonDeLivraisionImageFile, setBonDeLivraisionImageFile] = useState([]);
  const animatedComponents = makeAnimated();
  const [allWarehouseSource, setAllWarehouseSource] = React.useState([{}]);
  const [products, setProducts] = React.useState(null);
  const [showElement, setShowElement] = useState([]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [document, setDocument] = useState(null);
  const [transactions, setTransactions] = useState(null);

  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [note, setNote] = useState();

  const [typeProduit, setTypeProduit] = useState(1);
  const [availableBDCSelectPlaceHolder, setAvailableBDCSelectPlaceHolder] =
    useState("Choisir...");
  const [availableBDCSelectedOption, setAvailableBDCSelectedOption] =
    useState(null);

  const [allAvailableBDC, setAllAvailableBDC] = React.useState([{}]);

  const [bdcReference, setBdcReference] = useState("");

  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });
  const handlerChangeQt = (event) => {
    console.log("quantity", event.target.value);
    setAmount(event.target.value);
  };
  // const handlerChangeNbr = (event) => {
  //   setNbr(event.target.value);
  // };
  const onDeleteProduct = (id) => {
    setProductTableData(productTableData.filter((item) => item.id !== id));
    setProductMapById(productMapById.filter((item) => item.id !== id));
  };

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        // console.log("response", response);
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      }).finally(() => {
        stopLoading();
      })
    PurchaseService.allRefNotLiveredBDCNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableBDCSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableBDC(backendData);
          setAvailableBDCSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  }, []);
  useEffect(() => {
    products && setProduct(products[0].idProductPurchase);

    products && setCurrentQteProductPurchase(products[0].currentQte);
  }, [products]);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onChangeSelectedProduct = (selectedOptionn) => {
    setSelectedOption();
    setProduct(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
    // setCurrentQteProductPurchase(selectedOptionn.customElements.currentQte);

    PurchaseService.getProductPurchaseCurrentQte(selectedOptionn.value)
      .then((response) => {
        if (Object.keys(response.data)[0] === "currentQte") {
          setCurrentQteProductPurchase(response.data.currentQte);
        } else if (Object.keys(response.data)[0] === "error") {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme au niveau de serveur");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeBDCReferenceHandler = (selectedOptionn) => {
    setBdcReference(selectedOptionn.value);
    setAvailableBDCSelectedOption();

    setAvailableBDCSelectPlaceHolder(selectedOptionn.label);
  };

  // const onChangeFactureOrPurchaseOrderReferenceHandler = (event) => {
  //   setFactureOrPurchaseOrderReference(event.target.value);
  // };
  const onAddProductToList = (event) => {
    let name = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.id === product) {
          indexInDataTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      products.forEach((element) => {
        if (element.idProductPurchase === product) {
          name = element.productName;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (amount > currentQteProductPurchase) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : la quantité de ce produit est indisponible  "
      );
    } else if (amount === 0 || amount === "0") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la quantité doit etre sup a zero");
    } else {
      if (!exist && amount !== 0) {
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            idProductPurchase: product,
            stockedQte: amount,
            productName: productSelectPlaceHolder,
            type: typeProduit,
            note: note,
          },
        ]);
      } else if (exist && amount !== 0) {
        let typeProd = productTableData[indexInDataTable].type;
        if (typeProd !== typeProduit) {
          setProductTableData((previoustate) => [
            ...previoustate,
            {
              idProductPurchase: product,
              stockedQte: amount,
              productName: productSelectPlaceHolder,
              type: typeProduit,
              note: note,
            },
          ]);
        } else {
          let newState = update(productTableData, {
            [indexInDataTable]: {
              qte: { $set: amount },
            },
          });

          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : tu as actualisé la quantité de produit :  " +
            productSelectPlaceHolder
          );
          setProductTableData(newState);
        }
      }
    }
  };
  // const onAddProductToList = (event) => {
  //   let name = null;
  //   let exist = false;
  //   let indexInDataTable;
  //   try {
  //     productMapById.forEach((element, index) => {
  //       if (element.id === product) {
  //         indexInDataTable = index;

  //         exist = true;
  //         throw "Break";
  //       }
  //     });
  //   } catch (e) {
  //     if (e !== "Break") throw e;
  //   }

  //   try {
  //     products.forEach((element) => {
  //       if (element.idProductPurchase === product) {
  //         name = element.productName;
  //         throw "Break";
  //       }
  //     });
  //   } catch (e) {
  //     if (e !== "Break") throw e;
  //   }
  //   if (amount > parseInt(currentQteProductPurchase)) {
  //     setOpenErrorAlert(true);
  //     setErrorAlertText(
  //       "Erreur : la quantité de ce produit est indisponible  "
  //     );
  //   } else if (amount === 0) {
  //     setOpenErrorAlert(true);
  //     setErrorAlertText("Erreur : la quantité doit etre sup a zero");
  //   } else {
  //     if (!exist && amount !== 0) {
  //   setProductMapById((previoustate) => [
  //     ...previoustate,
  //     { id: product, quantity: amount, type: typeProduit, note: note },
  //   ]);
  //   setProductTableData(null);
  //   products.map((element) => {
  //     if(productTableData){
  //       setProductTableData([
  //         {
  //           idProductPurchase: element.value,
  //           stockedQte: element.customElements,
  //           productName: element.label,
  //           type: typeProduit,
  //           note: note,
  //         },
  //       ]);
  //     }else{
  //     setProductTableData((previoustate) => [
  //       ...previoustate,
  //       {
  //         idProductPurchase: element.value,
  //         stockedQte: element.customElements,
  //         productName: element.label,
  //         type: typeProduit,
  //         note: note,
  //       },
  //     ]);
  //   // });

  //   } else if (exist && amount !== 0) {
  //     let typeProd = productTableData[indexInDataTable].type;
  //     if (typeProd !== typeProduit) {
  //       setProductTableData((previoustate) => [
  //         ...previoustate,
  //         {
  //           idProductPurchase: product,
  //           stockedQte: amount,
  //           productName: productSelectPlaceHolder,
  //           type: typeProduit,
  //           note: note,
  //         },
  //       ]);
  //     } else {
  //       let newState = update(productTableData, {
  //         [indexInDataTable]: {
  //           qte: { $set: amount },
  //         },
  //       });
  //       // let newStateTwo = update(productMapById, {
  //       //   [indexInDataTable]: {
  //       //     qte: { $set: amount },
  //       //   },
  //       // });
  //       setOpenInfoAlert(true);
  //       setInfoAlertText(
  //         "Info : tu as actualisé la quantité de produit :  " +
  //           productSelectPlaceHolder
  //       );
  //       // setProductMapById(newStateTwo);
  //       setProductTableData(newState);
  //     }
  //   }
  //   }
  // };

  const handleNext = () => {
    if (activeStep === 0) {
      if (bdcReference === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : la réference est vide");
      } else if (
        (showElement.includes("PURCHASING_MANAGER") ||
          showElement.includes("ADMIN")) &&
        warehouseSourceId === 0
      ) {
        if (warehouseSourceId === 0) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : aucun dépot selectionné");
        }
      } else {
        startLoading();

        PurchaseService.getPurchaseByRefPOOrByRefFacture(
          bdcReference
        )
          .then((response) => {
            if (Object.keys(response.data)[0] === "InvalidReference") {
              setOpenInfoAlert(true);
              setInfoAlertText("Info : la réference est invalide");
            } else if (Object.keys(response.data)[0] === "RelatedToFacture") {
              setOpenInfoAlert(true);
              setInfoAlertText("Info : cette achat est liée a une facture");
            } else if (Object.keys(response.data)[0] === "AlreadyCompleted") {
              setOpenInfoAlert(true);
              setInfoAlertText("Info :l'operation d'achat est terminé");
            } else if (Object.keys(response.data)[0] === "error") {
              setOpenErrorAlert(true);
              setErrorAlertText(
                "Erreur : il ya un probléme au niveau de serveur"
              );
            } else {
              // aucune valeur par défaut : seulement les produits de la commande
              setProducts(
                response.data.ProductsPurchases.filter(
                  (element) => element.typeProduct === 1
                ).map((element) => ({
                  value: element.idProductPurchase,
                  label: element.productName,
                  customElements: element.currentQte,
                }))
              );
              setProductSelectPlaceHolder("Choisir...");
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
          })
          .catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : " + error);
          }).finally(() => {
            stopLoading();
          });
      }
    } else if (activeStep === 1) {
      if (productTableData.length === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :aucun produit à stocker");
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 2) {
      let validatePurchaseOrderToRealWarehouseModel = {
        idWarhouse: warehouseSourceId,
        idUser: getCurrentUserId(),
        productStockedByWarehouseModels: productTableData,
        reference: bdcReference,
        pathBonDeLivraison: "any",
      };
      console.log(
        "validatePurchaseOrderToRealWarehouseModel",
        validatePurchaseOrderToRealWarehouseModel
      );
      if (bonDeLivraisionImageFile.length !== 0) {
        const uploadData = new FormData();
        uploadData.append("picture", bonDeLivraisionImageFile);
        // pas de loader de page : les requêtes POST affichent déjà l'overlay global

        UploadAndDownloadService.uploadFile(
          "/retail/uploadFile/uploadFile/Bon_Livraison",
          uploadData
        )
          .then((response) => {
            if (response.data["success"]) {
              validatePurchaseOrderToRealWarehouseModel.pathBonDeLivraison =
                response.data.success;

              // PurchaseService.validatePurchaseOrderToRealWarehouse(
              //   validatePurchaseOrderToRealWarehouseModel
              // )
              //   .then((response) => {
              //     if (Object.keys(response.data)[0] === "success") {
              //       setOpenSuccessAlert(true);
              //       setSuccessAlertText("Enregistrement avec succées");
              //       setActiveStep((prevActiveStep) => prevActiveStep + 1);
              //     } else if (Object.keys(response.data)[0] === "error") {
              //       setOpenErrorAlert(true);
              //       setErrorAlertText(
              //         "Erreur : il ya un probléme au niveau de serveur"
              //       );
              //     } else if (Object.keys(response.data)[0] === "IsCompleted") {
              //       setOpenInfoAlert(true);
              //       setInfoAlertText("Info : l'opération est déja terminée");
              //     } else if (
              //       Object.keys(response.data)[0] === "InvalidateReference"
              //     ) {
              //       setOpenInfoAlert(true);
              //       setInfoAlertText(
              //         "Info : la réference de d'achat ou de facture n'est pas valide "
              //       );
              //     }
              //   })
              //   .catch(() => {
              //     setOpenErrorAlert(true);
              //     setErrorAlertText("Erreur : il ya un probléme de connexion");
              //   });
              PurchaseService.validatePurchaseOrderToRealWarehouse(
                validatePurchaseOrderToRealWarehouseModel
              )
                .then((response) => {
                  if (response.data["success"]) {
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    console.log("response po", response);
                    setOpenSuccessAlert(true);
                    setTransactions(
                      response.data["transactionOperationsResponse"]
                    );
                    setDocument(response.data.success);
                    setSuccessAlertText("Enregistrement avec succées");
                  } else if (Object.keys(response.data)[0] === "error") {
                    setOpenErrorAlert(true);
                    setErrorAlertText(
                      "Erreur : il ya un probléme au niveau de serveur"
                    );
                  } else if (Object.keys(response.data)[0] === "IsCompleted") {
                    setOpenInfoAlert(true);
                    setInfoAlertText("Info : l'opération est déja terminée");
                  } else if (
                    Object.keys(response.data)[0] === "InvalidateReference"
                  ) {
                    setOpenInfoAlert(true);
                    setInfoAlertText(
                      "Info : la réference de d'achat ou de facture n'est pas valider "
                    );
                  }
                })
                .catch(() => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur : il ya un probléme de connection");
                });
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          });
      } else {
        console.log(JSON.stringify(validatePurchaseOrderToRealWarehouseModel));

        PurchaseService.validatePurchaseOrderToRealWarehouse(
          validatePurchaseOrderToRealWarehouseModel
        )
          .then((response) => {
            if (response.data["success"]) {
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              console.log("response po", response);

              setOpenSuccessAlert(true);
              setTransactions(response.data["transactionOperationsResponse"]);
              setDocument(response.data.success);
              setSuccessAlertText("Enregistrement avec succées");
            } else if (Object.keys(response.data)[0] === "error") {
              setOpenErrorAlert(true);
              setErrorAlertText(
                "Erreur : il ya un probléme au niveau de serveur"
              );
            } else if (Object.keys(response.data)[0] === "IsCompleted") {
              setOpenInfoAlert(true);
              setInfoAlertText("Info : l'opération est déja terminée");
            } else if (
              Object.keys(response.data)[0] === "InvalidateReference"
            ) {
              setOpenInfoAlert(true);
              setInfoAlertText(
                "Info : la réference de d'achat ou de facture n'est pas valider "
              );
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          });
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
    // console.log("warehouseSourceID", selectedOptionn.value);
  };

  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setBonDeLivraisionImageFile(e.target.files[0]);
    }
  };
  // supprime une ligne du tableau (un même produit peut y figurer avec plusieurs types)
  const onDeleteProductRow = (row) => {
    setProductTableData((previous) =>
      previous.filter(
        (item) =>
          !(
            item.idProductPurchase === row.idProductPurchase &&
            item.type === row.type &&
            item.stockedQte === row.stockedQte &&
            item.note === row.note
          )
      )
    );
  };

  const columns = [
    {
      dataField: "productName",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "type",
      text: "type",
      align: "center",
      headerAlign: "center",
      formatter: lotFormatter,

      // headerStyle: () => {
      //   return { width: "6%" };
      // },
    },
    {
      dataField: "stockedQte",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      // headerStyle: () => {
      //   return { width: "6%" };
      // },
    },
    {
      dataField: "actions",
      text: "Action",
      isDummyField: true,
      align: "center",
      headerAlign: "center",
      headerStyle: () => ({ width: "10%" }),
      formatter: (cell, row) => (
        <button
          type="button"
          title="Supprimer cette ligne"
          className="btn btn-sm btn-outline-danger"
          style={{ width: 36 }}
          onClick={() => onDeleteProductRow(row)}
        >
          <i className="fas fa-trash"></i>
        </button>
      ),
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }
  const onValueChangeTypeProduit = (event) => {
    if (event.target.value === "1") {
      setTypeProduit(1);
    } else if (event.target.value === "2") {
      setTypeProduit(2);
    } else if (event.target.value === "3") {
      setTypeProduit(3);
    }
  };
  const onChangeNoteHandler = (event) => {
    setNote(event.target.value);
  };
  const onChangeInput = (e, employeeId) => {
    const { name, value } = e.target;

    const editData = products.map((item) =>
      item.value === employeeId && name ? { ...item, [name]: value } : item
    );

    console.log("products", editData);

    setProducts(editData);
  };
  const typeProduitNote = () => {
    if (typeProduit === 2) {
      return (
        <div className="row">
          <div className="form-group col-sm-12">
            <label htmlFor="inputDescription">Motif du refus</label>
            <textarea
              placeholder="Saisir..."
              onChange={onChangeNoteHandler}
              id="inputDescription"
              className="form-control"
              rows={2}
              defaultValue={""}
            />
          </div>
        </div>
      );
    }
  };
  function lotFormatter(cell, row) {
    // console.log("row", row);
    if (cell === 1) {
      return <span>Nouvel arrivage</span>;
    } else if (cell === 2) {
      return <span>Refusé</span>;
    } else if (cell === 3) {
      return <span>Arrivage du retours</span>;
    }
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <h5>Recevoir une commande du fournisseur</h5>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Taper la réference du bon de commande </label>

                  {/* <input
                    onChange={onChangeFactureOrPurchaseOrderReferenceHandler}
                    value={factureOrPurchaseOrderReference}
                    type="text"
                    required
                    id="inputClientCompany"
                    className="form-control"
                  /> */}

                  <Select
                    key="selectBdcReference"
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={availableBDCSelectedOption}
                    onChange={onChangeBDCReferenceHandler}
                    options={allAvailableBDC}
                    placeholder={availableBDCSelectPlaceHolder}
                  />
                </div>
              </div>

              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir le dépôt </label>
                  <Select
                    key="selectWarehouse"
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedWarehouseSource}
                    options={allWarehouseSource}
                    placeholder={warehouseSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <div class="form-group">
                  <label>Bon de livraison</label>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        accept="application/pdf, .jpg, .jpeg, .png"
                        type="file"
                        className="custom-file-input"
                        id="exampleInputFile10"
                        onChange={onUploadFileHandler}
                      />
                      <label class="custom-file-label" for="exampleInputFile10">
                        Entrer le bon de livraison
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div class="row">
              <div className="col-sm-6">
                <div class="form-group">
                  <label>Choisir le produit</label>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedProduct}
                    autosize={false}
                    options={products}
                    placeholder={productSelectPlaceHolder}
                  />
                </div>
              </div>

              <div className="col-sm-6">
                <div class="form-group">
                  <label>
                    Choisir la quantité ({currentQteProductPurchase})
                  </label>
                  <input
                    onChange={handlerChangeNbr}
                    type="number"
                    min="0"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
            </div> */}
            {/* <div className="row">
              <div className="col-sm-12">
                <div class="row">
                  <div className="col-sm-6">
                    <div class="form-group">
                      <th>Produit</th>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div class="form-group">
                      <th>Quantité max</th>
                    </div>
                  </div>
                </div>
                {products.map(({ value, label, customElements }) => (
                  <div key={value} class="row">
                    <div className="col-sm-6">
                      <div class="form-group">
                        <input
                          className="form-control"
                          name="label"
                          value={label}
                          type="text"
                          onChange={(e) => onChangeInput(e, value)}
                          placeholder="Type Name"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div class="form-group">
                        <input
                          name="customElements"
                          onChange={(e) => onChangeInput(e, value)}
                          type="number"
                          min="0"
                          value={customElements}
                          id="inputClientCompany"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            <div class="row">
              <div className="col-sm-6">
                <div class="form-group">
                  <label>Produit</label>
                  <Select
                    key="selectProduct"
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedProduct}
                    autosize={false}
                    options={products}
                    placeholder={productSelectPlaceHolder}
                  />
                </div>
              </div>

              <div className="col-sm-6">
                <div class="form-group">
                  <label>Quantité ({currentQteProductPurchase})</label>

                  <input
                    onChange={handlerChangeQt}
                    type="number"
                    min="0"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>Type de réception</label>
              <div>
                <div
                  role="group"
                  style={{
                    display: "inline-flex",
                    flexWrap: "wrap",
                    padding: 3,
                    borderRadius: 8,
                    backgroundColor: "#f1f3f5",
                    border: "1px solid #e9ecef",
                  }}
                >
                  {[
                    { value: 1, label: "Nouvel arrivage" },
                    { value: 2, label: "Refusé" },
                    { value: 3, label: "Arrivage du retours" },
                  ].map((o) => {
                    const active = typeProduit === o.value;
                    return (
                      <button
                        key={o.value}
                        type="button"
                        onClick={() => setTypeProduit(o.value)}
                        style={{
                          border: "none",
                          borderRadius: 6,
                          padding: "5px 16px",
                          fontSize: "0.9rem",
                          fontWeight: active ? 600 : 400,
                          color: active ? "#fff" : "#495057",
                          backgroundColor: active ? "#343a40" : "transparent",
                          boxShadow: active ? "0 1px 3px rgba(0,0,0,.2)" : "none",
                          cursor: "pointer",
                          transition: "background-color .15s, color .15s",
                        }}
                      >
                        {o.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {typeProduitNote()}
            <div class="row">
              <div className="col-sm-12  text-center">
                <button
                  style={{ marginBottom: 20 }}
                  className="btn btn-dark"
                  onClick={onAddProductToList}
                >
                  <i className="fas fa-plus mr-1"></i>
                  Ajouter à la liste
                </button>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableData && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableData}
                      columns={columns}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            headerClasses="thead-light"
                            wrapperClasses="table-responsive w-100"
                            striped
                            hover
                            condensed
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <style>{`
        .receive-form .form-group > label,
        .receive-form .input-group > label {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #6c757d;
        }
      `}</style>
      <section className="content-header">
        <div className="container-fluid">
          <div>
            <h4 className="mb-1">
              <i className="fas fa-dolly mr-2"></i>Recevoir une commande
            </h4>
            <small className="text-muted">
              Choisissez le dépôt et la commande, contrôlez les produits reçus
              puis validez l'entrée en stock
            </small>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mt-3">
            <div className="col-md-12">
              <div
                className="card card-outline card-dark receive-form"
                style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
              >
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                {activeStep === steps.length ? (
                  <div>
                    <div className="card-body">
                      <div className="text-center py-3">
                        <i
                          className="fas fa-check-circle fa-3x mb-3 d-block"
                          style={{ color: "#28a745" }}
                        ></i>
                        <h5>L'entrée en stock est terminée avec succès</h5>
                      </div>
                      <div className="row" style={{ marginTop: 0 }}>
                        {document && transactions && (
                          <DataTableTransactionEndRecieve
                            refFacture={document.ref}
                            listProduits={transactions}
                          />
                        )}
                      </div>
                    </div>
                    <div className="card-footer text-right">
                      <button className="btn btn-dark" onClick={handleReset}>
                        <i className="fas fa-undo mr-1"></i>
                        Nouvelle réception
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="card-body">{getStepContent(activeStep)}</div>

                    <div className="card-footer d-flex justify-content-between">
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-outline-secondary"
                        onClick={handleBack}
                      >
                        <i className="fas fa-arrow-left mr-1"></i>
                        Précédent
                      </button>

                      <button className="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1 ? (
                          <>
                            <i className="fas fa-check mr-1"></i>Terminer
                          </>
                        ) : (
                          <>
                            Suivant<i className="fas fa-arrow-right ml-1"></i>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ReceiveAPurchaseOrder);
